import { Package } from "lucide-react";

import { productImageUrl, productThumbUrl } from "@/lib/media.ts";
import { tintFor } from "@/lib/tints.ts";
import { cn } from "@/lib/utils.ts";

interface Props {
  imagePath: string | null | undefined;
  /** Semilla del color cuando no hay foto (id o nombre del producto). */
  seed: string;
  /** "full" para tarjetas grandes; "thumb" para miniaturas del ticket o tablas. */
  size?: "full" | "thumb";
  className?: string;
}

/**
 * Imagen de producto al estilo vitrina: la foto completa (sin recortar) sobre un
 * fondo neutro; sin foto, un fondo del color del producto con un ícono.
 */
export function ProductThumb({ imagePath, seed, size = "full", className }: Props) {
  const src = size === "full" ? productImageUrl(imagePath) : productThumbUrl(imagePath);
  if (src) {
    return (
      <div className={cn("overflow-hidden bg-[#f8fafa]", className)}>
        <img
          src={src}
          alt=""
          loading="lazy"
          decoding="async"
          className={cn("h-full w-full object-contain", size === "full" ? "p-3" : "p-1")}
        />
      </div>
    );
  }
  const [bg, fg] = tintFor(seed);
  return (
    <div
      className={cn("flex items-center justify-center", className)}
      style={{ background: bg, color: fg }}
      aria-hidden="true"
    >
      <Package className={size === "full" ? "h-12 w-12 opacity-80" : "h-5 w-5 opacity-80"} />
    </div>
  );
}
